import React from 'react';
import styled, { keyframes } from 'styled-components';

// HOC //
import withChat from 'hoc/withChat';

// Components //
import View from 'components/View';
import LoadingSpinner from 'components/LoadingSpinner';
import Subtitle from 'components/Subtitle';

const subtitleAnim = keyframes`
  0% {
    opacity: .32;
  }
  50% {
    opacity: .56;
  }
  100% {
    opacity: 0.32;
  }
`;

const Root = styled(View)`
  justify-content: center;
  align-items: center;
  flex: 1;

  & > ${ Subtitle } {
    animation: ${ subtitleAnim } 4s linear infinite;
  }
`;

const WaitingScreen = ({
  client,
  channel
}) => {
  return (
    <Root>
      <LoadingSpinner />
      <Subtitle color="light">
        { !client && 'Waiting to Initialize' }
        { client && !channel && 'Waiting for Channel'}
      </Subtitle>
    </Root>
  );
}

WaitingScreen.propTypes = {

};

export default withChat(WaitingScreen);
